import { KitDetails } from '../../../services/modules/kit/kitDetails/kitDetails.types';
import { OfflineDatabaseKit } from '../database/offlineDatabase/types/offlineDatabaseKit.types';

export default class OfflineKitToKitDetailsTransformers {
  static toKitDetails(offlineKit: OfflineDatabaseKit): KitDetails {
    return {
      id: offlineKit.id,
      name: offlineKit.name,
      code: offlineKit.code,
      active: offlineKit.active,
      type: offlineKit.type,
      description: offlineKit.description,
      resume: offlineKit.resume,
      imageUrl: offlineKit.imageUrl,
      wholesalePrice: offlineKit.wholesalePrice,
    };
  }
}
